import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconBarcode = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M19.375 27.05v-9.203a.5.5 0 1 1 1 0v9.203a.5.5 0 1 1-1 0m3.25.5a.5.5 0 0 0 .5-.5v-9.203a.5.5 0 1 0-1 0v9.203a.5.5 0 0 0 .5.5m5.5 0a.5.5 0 0 0 .5-.5v-9.203a.5.5 0 1 0-1 0v9.203a.5.5 0 0 0 .5.5m-2.75 0a.5.5 0 0 0 .5-.5v-9.203a.5.5 0 1 0-1 0v9.203a.5.5 0 0 0 .5.5m-8.25 0a.5.5 0 0 0 .5-.5v-9.203a.5.5 0 1 0-1 0v9.203a.5.5 0 0 0 .5.5m13.75.68h-13.75a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h13.75a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5m2.75-10.883a.5.5 0 0 0-.5.5v12.316a.5.5 0 1 0 1 0V17.847a.5.5 0 0 0-.5-.5M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24m-8.55 0c0-8.532-6.917-15.45-15.45-15.45S8.55 15.469 8.55 24 15.469 39.45 24 39.45 39.45 32.531 39.45 24m-25.076-6.653a.5.5 0 0 0-.5.5v12.316a.5.5 0 1 0 1 0V17.847a.5.5 0 0 0-.5-.5m16.501 0a.5.5 0 0 0-.5.5v9.203a.5.5 0 1 0 1 0v-9.203a.5.5 0 0 0-.5-.5',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconBarcode)
export default ForwardRef
